import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
import store from './store/index'
let router =  new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [{
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('./views/home/index.vue')
    },
    {
      path: '/service', //产品服务
      name: 'service',
      component: () => import('./views/service/index.vue')
    },
    {
      path: '/project', //项目案例
      name: 'project',
      component: () => import('./views/project/index.vue')
    },
    {
      path: '/news', //新闻中心
      name: 'news',
      component: () => import('./views/news/index.vue'),
      // children: [
      //   {
      //     path: 'detail',
      //     name: 'newsdetail',
      //     component: function () {
      //       return import(  './views/news/detail.vue')
      //     },
      //   }
      // ]
    },
    {
      path: '/news/detail', //新闻详情
      name: 'newsdetail',
      component: () => import('./views/news/detail.vue')
    },
    {
      path: '/project/detail', //项目详情
      name: 'projectdetail',
      component: () => import('./views/project/detail.vue')
    },
    {
      path: '/about', //关于我们
      name: 'about',
      component: () => import('./views/about/index.vue')
    },
    {
      path: '/contact', //联系我们
      name: 'contact',
      component: () => import('./views/contact/index.vue')
    },
  ]
})
router.beforeEach((to,from,next) => {
  localStorage.setItem('Tenant','0')
  store.commit('showData/setFileUrl',`https://szshsurvey.com/api_company/materials/`)
  next()
})
export default router